import { Card, Col, Row, Statistic, theme } from "antd";

const styleCardMetric = {
  textAlign: "right",
};

function DashboardPage() {
  const { token } = theme.useToken();
  return (
    <Row gutter={[token.padding, token.padding]}>
      <Col span={6}>
        <Card bordered={false} style={styleCardMetric}>
          <Statistic title="Total Users" />
        </Card>
      </Col>
      <Col span={6}>
        <Card bordered={false} style={styleCardMetric}>
          <Statistic title="Total Deposits" suffix="HKD" precision={2} />
        </Card>
      </Col>
      <Col span={6}>
        <Card bordered={false} style={styleCardMetric}>
          <Statistic title="Total Remittance" suffix="HKD" precision={2} />
        </Card>
      </Col>
      <Col span={6}>
        <Card bordered={false} style={styleCardMetric}>
          <Statistic title="Total Profit" suffix="HKD" precision={2} />
        </Card>
      </Col>
    </Row>
  );
}

export default DashboardPage;
